import LoadingIcon from './icon';

interface LoadingProps {
  text?: string;
  className?: string;
  size?: number;
  iconColor?: string;
}

const Loading: React.FC<LoadingProps> = (props) => {
  const { text, className = '', size = 30, iconColor } = props;
  return (
    <div className="w-full h-full transition-all  z-[99] absolute top-0 left-0 flex flex-col justify-center items-center">
      <LoadingIcon size={size} color={iconColor} />
      {text && (
        <span
          className={`pt-[20px] text-common-text-base-color  text-[16px]  tracking-wide ${className}`}
        >
          {text}
        </span>
      )}
    </div>
  );
};

export default Loading;
